module.exports = __webpack_public_path__ + "img/ca.9d6af0b5.svg";